import { FlowContextProvider, StepWrapper, useReturnToPath } from '@betterment/js-runtime';
import { SuccessFullScreen } from '@betterment/samba-react';
import { Route, Routes, useMatch } from 'react-router-dom';

import DeferralSettingsStep from './steps/DeferralSettingsStep';
import { ReviewSelectionsStep } from './steps/ReviewSelectionsStep';

import { IdempotencyProviderWithFeatureRegistry } from '../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { locationAssign } from '../Shared/path-helpers';
import { urlBuilder } from '../Shared/urlBuilder';

export default function Controller() {
  const match = useMatch({ path: '/employers/:employerId/*' });
  const returnToPath = useReturnToPath(urlBuilder.appHome.absolute());

  return (
    <IdempotencyProviderWithFeatureRegistry featureName="createEmployeeContributionConfigChange">
      <FlowContextProvider basePath={match!.pathnameBase} routePath="" returnToPath={returnToPath}>
        <Routes>
          <Route
            data-feature="investing_four_oh_one_k"
            path="deferral_settings"
            element={
              <StepWrapper name="deferral_settings">{stepProps => <DeferralSettingsStep {...stepProps} />}</StepWrapper>
            }
          />
          <Route
            data-feature="investing_four_oh_one_k"
            path="review"
            element={<StepWrapper name="review">{stepProps => <ReviewSelectionsStep {...stepProps} />}</StepWrapper>}
          />
          <Route
            data-feature="investing_four_oh_one_k"
            path="success"
            element={
              <StepWrapper name="success">
                <SuccessFullScreen
                  message="You've updated your 401(k) contributions"
                  onCompletion={() => locationAssign(returnToPath)}
                />
              </StepWrapper>
            }
          />
        </Routes>
      </FlowContextProvider>
    </IdempotencyProviderWithFeatureRegistry>
  );
}
